import { ContentfulReport, Report } from '../types'
import { getPreviewReport, getReport, getReports } from './api/contentful'
import { printError } from './log'
import { withProtocol } from './url'

export const fetchReports = async () => {
  let reports: Report[] = []
  try {
    const contentfulReports = await getReports()
    reports = contentfulReports.map((contentfulReport) =>
      convertReport(contentfulReport)
    )
  } catch (e) {
    printError(e)
  }
  return reports
}

export const fetchReport = async (id: string) => {
  let report
  try {
    const contentfulReport = await getReport(id)
    report = convertReport(contentfulReport)
  } catch (e) {
    printError(e)
  }
  return report
}

export const fetchPreviewReport = async (id: string) => {
  let report
  try {
    const contentfulReport = await getPreviewReport(id)
    report = convertReport(contentfulReport)
  } catch (e) {
    printError(e)
  }
  return report
}

export const convertReport = (report: ContentfulReport): Report => {
  const reportFile = report.reportFile
    ? {
        url: withProtocol(report.reportFile.fields.file.url),
        title: report.reportFile.fields.title,
      }
    : undefined

  const headerImage = {
    url: withProtocol(report.headerImage.fields.file.url),
    title: report.headerImage.fields.title,
  }

  return {
    ...report,
    headerImage,
    reportFile,
  }
}
